import ConditionalTooltip from "./conditionalTooltip";

export default ConditionalTooltip;
